export function isP2PKH(address) {
    // Check if the provided address is a P2PKH address
    return address[0] === '1' || address[0] === 'm' || address[0] === 'n';
}
export function stringToNumber(str) {
    if (typeof str !== 'string') {
        throw new Error(`Expected a string but received type ${typeof str} instead`);
    }
    const number = Number(str);
    if (!Number.isSafeInteger(number)) {
        throw new Error('Invalid number or value exceeds the safe integer range for Number.');
    }
    return number;
}
